module.exports = __webpack_public_path__ + "static/hero-transportation-ind-4438b46f3d1fc5acbeace4d17fc56f66.png";